import { AxiosResponse } from 'axios';

import { SFCCBasket } from '../../../models/sfcc-basket';
import { makeCurrentBasketAction } from '../../../utilities/make-current-basket-action';
import { shopHttp } from '../../basket-api';

interface SetEngravingMessageBody {
  c_engravingMsg: string;
  quantity: number;
}

export const setEngravingMessage = async (
  itemId: string,
  quantity: number,
  engravingMessage: string,
  ensureBasketMethod: () => Promise<SFCCBasket>
): Promise<SFCCBasket> => {
  const body: SetEngravingMessageBody = { c_engravingMsg: engravingMessage, quantity };

  return await makeCurrentBasketAction(
    `items/${itemId}`,
    setEngravingMessageToProduct,
    ensureBasketMethod,
    body
  );
};

const setEngravingMessageToProduct = async (
  requestPath: string,
  body: SetEngravingMessageBody
): Promise<SFCCBasket> => {
  const response = await shopHttp.patch<SetEngravingMessageBody, AxiosResponse<SFCCBasket>>(
    requestPath,
    body
  );

  return response.data;
};
